const styles = {
    button: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        borderRadius: '16px',
        fontSize: '16px',
        textTransform: 'none',
        marginTop: '40px',
        backgroundColor: '#3876AA',
        color: '#FFFFFF',
    },
    error_message: {
        marginTop: '24px',
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
    },
    title: {
        fontFamily: 'Silka_Medium',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '18px',
        color: '#8697AB',
    },
    employerName: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '27px',
        marginTop: '8px',
    },
    plain_text: {
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
    },
    note: {
        fontFamily: 'Silka_Medium',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '18px',
        color: '#3876AA',
        marginTop: '24px',
        marginBottom: '24px',
    },
    uploadContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F7F8FC',
        borderRadius: '8px',
        padding: '36px',
        border: '1px dashed #3D87BF',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    chooseFile: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        marginTop: '12px',
    },
    partnerContainer: {
        background: '#F7F8FC',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '24px',
    },
    ml_16: {
        marginLeft: '16px',
    },
    mt_16: {
        marginTop: '16px',
    },
    mr_8: {
        marginRight: '8px',
    },
    bw_2: {
        borderWidth: '2px',
    },
};
export default styles;
